type Identity = {
    user_id: string | number
    user_hash: string
} & Record<string, unknown>

export function useIntercomHelpers() {
    const { $intercom } = useNuxtApp();
    const { status, data: session } = useAuth();

    const buildIdentity = (): Identity | null => {
        if(status.value !== 'authenticated') {
            return null;
        }

        const u: any = session.value?.data ?? {};
        const user_id = u?.intercom_id;
        const user_hash = u?.intercom_hash;

        if(!user_id || !user_hash) {
            return null;
        }

        return { user_id, user_hash };
    }

    const attachLoggedUser = async () => {
        if(!import.meta.client) {
            return
        }

        await $intercom.onceReady();
        const id = buildIdentity();

        if(id) {
            $intercom.identify(id);
        }
    }

    const showIntercom = async () => {
        await $intercom.onceReady();
        $intercom.show();
    }

    return {
        attachLoggedUser,
        showIntercom,
    }
}
